import {
	TOGGLE_SITE_TRACKER_DIALOG,
	SET_FORM_STATE,
	GET_SITE_TRACKER_TABLE,
	GET_SITE_TRACKER_UPDATE_TABLE,
	TOGGLE_SITE_TRACKER_UPDATE_VISIBILITY,
	GET_SITE_TRACKER_CREATE_LCS_TABLE,
	TOGGLE_SITE_TRACKER_LCS_CREATE_VISIBILITY,
	GET_DROPDOWNS,
	GET_SITE_NAME_DROPDOWN,
	GET_SITE_DASZONE_DROPDOWN,
	GET_SITE_TRACKER,
	GET_COMMENTS_HISTORY,
	GET_SITE_TRACKER_TO_EDIT,
	TOGGLE_IMPORT_MODAL_VISIBILITY,
	GET_BSH_DROPDOWN,
	GET_SITE_TYPE_DROPDOWN
} from '../actions/SiteTrackerActions';

const initialState = {
	siteTrackerTable: [],
	siteTrackerUpdateTable: [],
	siteTrackerCreateLCSTable: [],
	siteListToUpdate: [],
	commentsHistory: {},
	siteTrackerDialogVisibility: false,
	siteTrackerUpdateVisibility: false,
	siteTrackerLCSCreateVisibility: false,
	selectedSiteId: 0,
	dropdowns: [],
	siteNameDropdown: [],
	siteDasZoneDropdown: [],
	siteBshDropdown: [],
	siteTypeDropdown: [],
	formState: {
		values: {},
		isValid: false,
		touched: {},
		errors: {},
		submit: false
	},
	importModalVisibility: false
};

const siteTrackerReducer = (state = initialState, action) => {
	switch (action.type) {
					case TOGGLE_SITE_TRACKER_DIALOG: {
						return {
							...state,
							siteTrackerDialogVisibility: action.visible,
							selectedSiteId: action.siteTrackerId,
							formState: initialState.formState,
							dropdowns: initialState.dropdowns,
							siteNameDropdown: initialState.siteNameDropdown,
							siteDasZoneDropdown: initialState.siteDasZoneDropdown,
							siteBshDropdown: initialState.siteBshDropdown,
							siteTypeDropdown: initialState.siteTypeDropdown,
							commentsHistory: initialState.commentsHistory
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_SITE_TRACKER_TABLE: {
						return {
							...state,
							siteTrackerTable: action.siteTrackerTable
						};
					}
					case GET_SITE_TRACKER_UPDATE_TABLE: {
						return {
							...state,
							siteTrackerUpdateTable: action.siteTrackerUpdateTable
						};
					}
					case GET_SITE_TRACKER_CREATE_LCS_TABLE: {
						return {
							...state,
							siteTrackerCreateLCSTable: action.siteTrackerCreateLCSTable
						};
					}
					case TOGGLE_SITE_TRACKER_UPDATE_VISIBILITY: {
						return {
							...state,
							siteTrackerUpdateVisibility: action.siteTrackerUpdateVisibility,
						};
					}
					case TOGGLE_SITE_TRACKER_LCS_CREATE_VISIBILITY: {
						return {
							...state,
							siteTrackerLCSCreateVisibility: action.siteTrackerLCSCreateVisibility,
						};
					}
					case GET_COMMENTS_HISTORY: {
						return {
							...state,
							commentsHistory: {
								...state.commentsHistory,
								[action.commentType]: action.commentsHistory
							}
						};
					}
					case GET_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case GET_SITE_NAME_DROPDOWN: {
						return {
							...state,
							siteNameDropdown: action.siteNameDropdown
						};
					}
					case GET_SITE_DASZONE_DROPDOWN: {
						return {
							...state,
							siteDasZoneDropdown: action.siteDasZoneDropdown
						};
					}
					case GET_SITE_TRACKER: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.siteTracker }
							}
						};
					}
					case GET_SITE_TRACKER_TO_EDIT: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.siteTracker }
							}
						};
					}
					case TOGGLE_IMPORT_MODAL_VISIBILITY: {
						return {
							...state,
							importModalVisibility: action.importModalVisibility
						};
					}
					case GET_BSH_DROPDOWN: {
						return {
							...state,
							siteBshDropdown: action.siteBshDropdown
						};
					}
					case GET_SITE_TYPE_DROPDOWN: {
						return {
							...state,
							siteTypeDropdown: action.siteTypeDropdown
						};
					}
					default: {
						return state;
					}
	}
};

export default siteTrackerReducer;
